import React, { useEffect, useState } from 'react';
import ApacheEcharts from '../../ApacheEcharts';
import "./GraficoPizza.css";

function GraficoPizza({ dadosGrafico }) {

    const { titulo, dados } = dadosGrafico;

    const [option, setOption] = useState({});
    const style = { width: "100%", height: "200px", padding: "0px", minWidth: "478px" };

    useEffect(() => {
        const data = [];

        for (let i = 0; i < dados.length; i++) {
            data.push({ value: dados[i]['realizado'], name: formatarLegenda(dados[i]['departamento']) });
        }

        const option = {
            tooltip: {
                trigger: 'item',
                valueFormatter: (value) => parseFloat(value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}),
                axisPointer: {
                    type: "shadow"
                }
            },
            legend: {
                orient: 'vertical',
                right: '1%',
                icon: 'circle',
                textStyle: {
                    fontSize: 10
                }
            },
            series: [
                {
                    type: 'pie',
                    radius: '60%',
                    center: ['27%', '50%'],
                    data: data,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    label: {
                        formatter: '{d}%',
                        fontSize: 10,
                        distanceToLabelLine: 1,
                        bleedMargin: 1,
                        edgeDistance: 1
                    },
                }
            ]
        }

        setOption(option);

    }, [dados]);

    function formatarLegenda(string) {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    }

    return (
        <div className='card-pizza'>
            <div className='card-header-pizza font-titulo-pizza'>
                <h4 className='uppercase'>{titulo}</h4>
                <span className='text-[10px]' style={{ color: '#888888' }}>Valores reais por departamento.</span>
            </div>
            {dados.length > 0 ? (
                <ApacheEcharts option={option} style={style} />
            ) : (
                <p className='p-info-pizza font-titulo-pizza'>Sem dados no momento!</p>
            )} 
        </div>
    );
}

export default GraficoPizza